import { render, staticRenderFns } from "./index_pc.vue?vue&type=template&id=773c2038&scoped=true&"
import script from "./index_pc.vue?vue&type=script&lang=js&"
export * from "./index_pc.vue?vue&type=script&lang=js&"
import style0 from "./index_pc.vue?vue&type=style&index=0&id=773c2038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c2038",
  null
  
)

export default component.exports